import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import TutorialVideosImg from 'src/assets/images/tutorial-videos.png';
import { BlueButton } from 'src/components/components/index';
import { Routes } from 'src/constants/index';
import './style.scss';

interface IProps extends RouteComponentProps {}

class TutorialVideosComponent extends React.Component<IProps, null> {
  goToVideos = () => {
    this.props.history.push(Routes.MemberVideos);
  };

  render(): React.ReactNode {
    return (
      <div className="tutorial-videos">
        <div className="tutorial-videos__wrapper">
          <div className="tutorial-videos__info-wrapper">
            <p className="tutorial-videos__title">
              <FormattedMessage id="member.tutorial.videos" />
            </p>
            <p className="tutorial-videos__description">
              <FormattedMessage id="get.the.most.out.of.your.membership" />
            </p>
            <div className="tutorial-videos__btn-wrapper">
              <BlueButton onClick={this.goToVideos}>
                <FormattedMessage id="watch.videos" />
              </BlueButton>
            </div>
          </div>
          <div className="tutorial-videos__img-wrapper">
            <img src={TutorialVideosImg} alt="watch.videos" />
          </div>
        </div>
      </div>
    );
  }
}

export const TutorialVideos = withRouter(TutorialVideosComponent);
